import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { NextTaskComponent } from 'src/app/Dashboards/follow-next-task/follow-next-task.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { Task } from 'src/model/task.model';

@Component({
    selector: 'app-customer-task-list',
    templateUrl: './customer-task-list.component.html',
    styleUrls: ['./customer-task-list.component.scss'],
    standalone: false
})
export class CustomerTaskListComponent implements OnInit, OnChanges {
  private restapi = inject(RestApiService);
  private constructAPI = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  @Input() viewCustomer: Customer;
  @Input() allowUpdateTask = true;
  @Input() selectedProfileId: number;

  customerTaskList: Task[] = [];

  ngOnInit() {

    // this.getCustomerTaskInfo();
  }
  ngOnChanges() {
    if (this.customerTaskList.length > 0)
      this.customerTaskList.splice(0, this.customerTaskList.length);
    this.getCustomerTaskInfo();
  }

  getCustomerTaskInfo() {

    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/tasks?customerId=" + this.viewCustomer.ID;
    // xhttp.withCredentials = true;

    const xhttp = this.restapi.getRequest(this.constructAPI.getTaskOfProfile(this.selectedProfileId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {

          // create customer instance with all response data
          const task = new Task(json.id, json.customerId, json.description, json.followUpRemark, json.date, json.customerName, json.assignee,
            json.dateDone, undefined, json.profileId, json.type);
          //add task instance into task list

          this.customerTaskList.push(task);

          this.customerTaskList.sort((a, b) => (b.Date > a.Date) ? 1 : -1);

          // console.log(this.customerPaymentList);
        }
        );
      }
    };
    // xhttp.open("GET", url, true);
    // xhttp.send();

  }

  getTaskStatusString(dateDone: Date) {
    if (dateDone == undefined)
      return "PENDING";
    else
      return "DONE";
  }
  changeStatusColor(dateDone: Date) {

    if (dateDone != undefined)
      return 'green'
    else
      return 'red'
  }

  openNextTaskModal(task: Task) {
    const modalRef = this.sharedService.openModal(NextTaskComponent);
    modalRef.componentInstance.task = task;

    if (task.Type == this.enums.EPF_TASK)
      modalRef.componentInstance.isEPF = true;

  }

}
